import { render, staticRenderFns } from "./ShofurSecure.vue?vue&type=template&id=600bb090&scoped=true"
var script = {}
import style0 from "./ShofurSecure.vue?vue&type=style&index=0&id=600bb090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bb090",
  null
  
)

export default component.exports